export const validateJsonld = (jsonld?: string): string | undefined => {
  try {
    if (typeof jsonld === 'string') {
      return JSON.stringify(JSON.parse(jsonld))
    }

    return undefined
  } catch (_error) {
    return undefined
  }
}
